import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import routes from '../routes';

export function Home() {
  const { user } = useAuth();
  return <Navigate replace to={user ? routes.quotations.path : routes.login.path} />;
}
